import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ApiCatalogPageRoutingModule } from './api-catalog-routing.module';

import { SharedModule } from '../shared/shared.module';
import { ApiCatalogViewComponent } from './api-catalog-view/api-catalog-view.component';
import { ApiCatalogCreateComponent } from './api-catalog-create/api-catalog-create.component';
import { ApiCatalogUpdateComponent } from './api-catalog-update/api-catalog-update.component';
import { ApiCatalogDetailsComponent } from './api-catalog-details/api-catalog-details.component';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
// import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ApiCatalogPageRoutingModule,
    NgJsonEditorModule,
    SharedModule,
    CodemirrorModule,
    MonacoEditorModule
    // MonacoEditorModule.forRoot()
  ],
  declarations: [
    ApiCatalogViewComponent,
    ApiCatalogCreateComponent,
    ApiCatalogUpdateComponent,
    ApiCatalogDetailsComponent,
  ]
})
export class ApiCatalogPageModule {}
